
import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

interface EmailContentManagerProps {
  initialContent: string;
  onSave: (content: string) => Promise<void>;
  title: string;
  description?: string;
}

export const EmailContentManager: React.FC<EmailContentManagerProps> = ({
  initialContent,
  onSave,
  title,
  description
}) => {
  const [content, setContent] = useState(initialContent);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave(content);
      toast.success('E-post innhold lagret');
    } catch (error) {
      toast.error('Kunne ikke lagre e-post innhold');
      console.error('Error saving email content:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <p className="text-sm text-gray-500">{description}</p>}
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="emailContent">E-post innhold</Label>
            <Textarea
              id="emailContent"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows={12}
              className="font-mono text-sm"
            />
          </div>
          <Button 
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? 'Lagrer...' : 'Lagre endringer'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
